import { get } from "lodash"

export const getToken = (_, props) => get(props, "params.token")
